import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation, Trans } from 'react-i18next'
import TwoCol from '../../partials/TwoCol'
import '../../sass/innerPages.sass'
import MainTitle from '../../partials/MainTitle'
import medic from '../../img/medic.jpg'
import medicscr from '../../img/medicscr.jpg'
import medicFont from '../../img/medicFont.jpg'

function Medic() {
  const { t } = useTranslation();
  
  useEffect(()=>{
    window.scrollTo(0, 0);
  },[]);

  return (
    <div className='container'>
      <MainTitle title={t('medicTitle')} />
      <TwoCol contentOne={<ContentOne />} contentTwo={<ContentTwo />} />
      <div className='txtContainer mt-50 px-20'>
        <h2>{t('designDecisions')}</h2>
        <p><Trans i18nKey="medicDDTxt"></Trans></p>
        <figure>
          <img className='image-fluid' src={medicFont} alt="Typescale" />
          <figcaption>Villa Medić font</figcaption>
        </figure>
        <ul className='colors'>
          <li><span className='color' style={{background: "#001854"}}></span> #001854</li>
          <li><span className='color' style={{background: "#214ED5"}}></span> #214ED5</li>
          <li><span className='color' style={{background: "#6E6B65"}}></span> #6E6B65</li>
          <li><span className='color' style={{background: "#625331"}}></span> #625331</li>
          <li><span className='color' style={{background: "#8C7331"}}></span> #8C7331</li>
          <li><span className='color' style={{background: "#F0AB6C"}}></span> #F0AB6C</li>
          <li><span className='color' style={{background: "#F5F5F5"}}></span> #F5F5F5</li>
        </ul>
        <h2>{t('figmaScr')}</h2>
        <figure>
          <img className='image-fluid' src={medicscr} alt={t('figmaScr')} />
          <figcaption>{t('medicScrCaption')}</figcaption>
        </figure>
        <Link className="btn btn-link btn-inner mt-20" to={"https://villamedic-brela.com/hr/"} target="_blank">{t('seeWebpage')}</Link>
      </div>
    </div>
  )
}

export default Medic

function ContentOne() {
  return(
    <img className="image-fluid" src={medic} alt="Villa Medić" />
  );
}

function ContentTwo() {
  const { t } = useTranslation();

  return(
    <div className='innerMain mx-50'>
      <p className='mt-0'>{t('medicMainTxt')}</p>
      <Link className="btn btn-link mt-20" to={"https://villamedic-brela.com/hr/"} target="_blank">{t('seeWebpage')}</Link>
      <h2 className='mt-50 mb-0'>{t('mainProblem')}</h2>
       <p className='problem'><Trans i18nKey="medicMainText2">
        The main problem to solve was: <br/><i>How to present Villa in best possible way and make design eye catching and information architecture more logical.</i>
      </Trans></p>
    </div>
  );
}